module.exports = __webpack_public_path__ + "static/img/6.32a40fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/6.jpg
// module id = s5NT
// module chunks = 1